/**
 * control the auto scroll speed (in px)
 */
export const SCROLL_SPEED = 1;
export const SCROLL_INTERVAL_MS = 20;

/**
 * max items on page
 */
export const MAX_ITEMS = 100;

/**
 * max allowable items to fetch each time
 */
export const SEARCH_LIMIT = 20;
